<template>
  <div class="config-panel top-right">
    <!-- 行星配置 -->
    <div class="config-box">
      <div class="config-header">
        <button class="config-btn" @click.stop="$emit('show-planet-config')">行星配置</button>
        <label class="config-toggle">
          <input type="checkbox" v-model="showPlanetList"> 显示
        </label>
      </div>
      <div v-if="showPlanetList" class="selected-list">
        <!-- 修改为两列布局 -->
        <div class="two-columns">
          <div v-for="planet in selectedPlanets" :key="planet.id" class="selected-item">
            {{ planet.name }}
          </div>
        </div>
      </div>
    </div>

    <!-- 恒星配置 -->
    <div class="config-box" v-if="hasPermission('full_stars')">
      <div class="config-header">
        <button class="config-btn" @click="$emit('show-star-config')">恒星配置</button>
        <label class="config-toggle">
          <input type="checkbox" v-model="showStarList"> 显示
        </label>
      </div>
      <div v-if="showStarList" class="selected-list">
        <div class="two-columns">
          <div v-for="star in selectedStars" :key="star.id" class="selected-item">
            {{ star.name }}
          </div>
        </div>
      </div>
    </div>

    <!-- 逻辑点配置 -->
    <div class="config-box" v-if="hasPermission('logic_points')">
      <div class="config-header">
        <button class="config-btn" @click="$emit('show-point-config')">逻辑点</button>
        <label class="config-toggle">
          <input type="checkbox" v-model="showPointList"> 显示
        </label>
      </div>
      <div v-if="showPointList" class="selected-list">
        <div class="two-columns">
          <div v-for="point in selectedPoints" :key="point.id" class="selected-item">
            {{ point.name }}
          </div>
        </div>
      </div>
    </div>

    <!-- 催贵公式配置 -->
    <div class="config-box" v-if="hasMidpointPermission">
      <div class="config-header">
        <button class="config-btn" @click="$emit('show-midpoint-config')">催贵公式</button>
        <label class="config-toggle">
          <input type="checkbox" v-model="showMidpointList"> 显示
        </label>
      </div>
      <div v-if="showMidpointList" class="selected-list">
        <div class="two-columns">
          <div v-for="(pair, index) in selectedMidpoints" :key="index" class="selected-item">
            {{ pair.planet1Name }}-{{ pair.planet2Name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionService from '@/services/PermissionService'
export default {
  name: 'ConfigPanel',
  props: {
    selectedPlanets: {
      type: Array,
      default: () => []
    },
    selectedStars: {
      type: Array,
      default: () => []
    },
    selectedPoints: {
      type: Array,
      default: () => []
    },
    selectedMidpoints: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasMidpointPermission () {
      const granted = this.permissions.includes('midpoint_formula')
      console.log('[ConfigPanel] midpoint permission snapshot', {
        granted,
        propPermissions: this.permissions,
        servicePermissions: PermissionService.getPermissions()
      })
      return granted
    }
  },
  methods: {
    hasPermission (key) {
      return this.permissions.includes(key)
    }
  }
}
</script>

<style scoped>
.config-panel.top-right {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.config-box {
  background: rgba(255, 255, 255, 0.0);
  border-radius: 8px;
  padding: 4px;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15); */
}

.config-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.config-btn {
  flex: 1;
  padding: 4px 8px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  height: 26px;
  margin-right: 10px;
}

/* 【临时屏蔽】行星配置 / 恒星配置 / 逻辑点 / 催贵公式 四个按钮右侧的
   「显示 + 勾选框」暂不展示。恢复方式：把下面这行 display 改回 flex 即可。 */
.config-toggle {
  display: none; /* 原值：flex */
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #000;
}

.config-toggle input[type="checkbox"] {
  margin: 0;
  width: 14px;
  height: 14px;
}

.selected-list {
  max-height: 200px;
  overflow-y: auto;
  padding: 6px;
}

/* 新增两列布局 */
.two-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.selected-item {
  padding: 4px 0;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 溢出显示省略号 */
}
</style>
